<template lang="html">

  <!-- Footer -->
  <footer class="footer footer-dark">
    <section class="footer-section">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-lg-4 sm-m-15px-tb md-m-30px-b">
            <h4 class="font-alt">About</h4>
            <p class="footer-text">Codoc is documentation system built around your code.</p> <!-- Insert mission statement -->
            <!-- <ul class="social-icons">
              <li><a class="facebook" href="#"><i class="fab fa-facebook-f"></i></a></li>
              <li><a class="twitter" href="#"><i class="fab fa-twitter"></i></a></li>
              <li><a class="google" href="#"><i class="fab fa-google-plus-g"></i></a></li>
              <li><a class="linkedin" href="#"><i class="fab fa-linkedin-in"></i></a></li>
            </ul> -->
          </div> <!-- col -->
          <!-- <div class="col-6 col-md-4 col-lg-2 sm-m-15px-tb">
            <h4 class="font-alt">Product</h4>
            <ul class="fot-link">
              <li><a href="#">Features</a></li>
              <li><a href="#">Carrers</a></li>
              <li><a href="#">Awards</a></li>
              <li><a href="#">Users Program</a></li>
              <li><a href="#">Locations</a></li>
            </ul>
          </div> col -->
          <!--
          <div class="col-6 col-md-4 col-lg-2 sm-m-15px-tb">
            <h4 class="font-alt">Company</h4>
            <ul class="fot-link">
                <li><a href="#">About</a></li>
                <li><a href="#">Blog</a></li>
                <li><a href="#">Press</a></li>
                <li><a href="#">Policy</a></li>
                <li><a href="#">Contact</a></li>
              </ul>
          </div> -->
          <div id="contact" class="col-md-4 col-lg-4 sm-m-15px-tb">
            <h4 class="font-alt">Contact</h4>
            <div class="fot-address">
              <!-- <p><i class="ti-location-arrow"></i>301 The Greenhouse<br/>London, E2 8DY<br/>UK</p>
              <p><i class="ti-headphone"></i> +01 440 444 4526</p> -->
              <p><i class="fas fa-envelope"></i>contact@codoc.dev</p>
              <!-- <p><i class="ti-info"></i>Dana is a project by <a href="https://www.linkedin.com/in/kgsun" target="_blank" style="color:#fff;">Kevin Sun</a> and others.</p> -->
            </div>
          </div> <!-- col -->
        </div>
        <div class="footer-copy">
          <div class="row">
            <div class="col-12">
              <p>All © Copyright by Codoc, Inc. All Rights Reserved.</p>
            </div><!-- col -->
          </div> <!-- row -->
        </div> <!-- footer-copy -->

      </div> <!-- container -->
    </section>
  </footer>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
  @import '~styles/variables.scss';
  @import '~styles/basetheme';
  @import '~styles/basecolors';
</style>
